<template>
<div class="ActvityTempBusiness">
    <div class="bgc box-shadow ActvityTempBusiness-title">
        <div class="classes blod">{{item.eventname}}</div>
    </div>
    <div class="filters padding-20 bgc">
        <div class="add">
        </div>
        <div class="search">
            <el-input v-model="param.rolehostname" placeholder="请输入昵称查询" class="condition" clearable></el-input>
            <el-select v-model="param.eventstatus" placeholder="活动状态" class="condition" clearable>
                <el-option v-for="item in statusList" :key="item.code" :label="item.name"
                           :value="item.code"></el-option>
            </el-select>
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list padding-20 bgc">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="headername" label="商家昵称"  min-width="250px" class-name="title">
                <template slot-scope="scope">
                    <div class="imageText">
                        <img class="img" v-lazy="scope.row.rolehosturl" :alt="scope.row.rolehostname" preview="ActvityTempBusiness">
                        <span>{{scope.row.rolehostname}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="datatime" label="复制时间" class-name="center"></el-table-column>
            <el-table-column prop="viewcount" label="浏览量" class-name="center"></el-table-column>
            <el-table-column prop="ordersucccount" label="订单数" class-name="center"></el-table-column>
            <el-table-column prop="ordermoney" label="销售额" class-name="center">
                <template slot-scope="scope">￥{{scope.row.ordermoney}}</template>
            </el-table-column>
            <el-table-column prop="brokeragepaystatus " label="活动状态" label-class-name="tr" class-name="tr">
                <template slot-scope="scope"><div :class="eventstatus(scope.row.eventstatus)">{{scope.row.eventstatusname}}</div></template>
            </el-table-column>
        </el-table>
        <div class="page" style="margin-top: 15px; text-align: center">
            <el-pagination
                background
                @current-change="handleSizeChange"
                :current-page.sync="page.page"
                :page-size="page.pageSize"
                :pager-count="11"
                layout="prev, pager, next"
                :total="total">
            </el-pagination>
        </div>
    </div>
</div>
</template>

<script>
import {getProviderByRolehostList} from 'api/brandBusiness'
import {brandBusiness} from 'api/enumCode'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'ActvityTempBusiness',
    data() {
        return {
            item: {
                eventname: this.$route.query.title ? this.$route.query.title : '',
            },
            param: {
                eventid: this.$route.query.eventid ? this.$route.query.eventid : '',
                eventstatus: '',
                rolehostname: ''
            },
            statusList: brandBusiness.eventstatus,
            total: 0,
            tableData: [],
            page: {
                page: 1,
                pageSize: 5,
                pageCount: 0
            },
        }
    },
    mounted() {
        this._getList()
    },
    methods: {
        handleQuery() {
            this.page.page = 1
            this._getList()
        },
        handleSizeChange() {
            this._getList()
        },
        _getList() {
            this.setLoading(true)
            getProviderByRolehostList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.datalist
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([ 'setLoading'])
    },
    filters: {},
    watch: {},
    computed: {
        eventstatus() {
            return function (value) {
                for (let i = 0; i < brandBusiness.eventstatus.length; i++) {
                    if (value === brandBusiness.eventstatus[i].code) {
                        return brandBusiness.eventstatus[i].cls
                    }
                }
                return value
            }
        }
    },
    components: {
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.ActvityTempBusiness {
    .ActvityTempBusiness-title {
        @include flexBox(space-between);
        height: 60px;
        padding: 0 20px;
        margin-bottom: 30px;
        .classes {
            margin-bottom: 0;
        }
        .el-input__icon {
            line-height: 1;
        }
    }
    .filters{
        margin-bottom: 0;
    }
    .imageText{
        .img{
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
}
</style>
